import * as React from 'react'

import {BsInstagram, BsFacebook, BsTwitterX, BsTiktok, BsYoutube, BsGithub, BsDiscord, BsLinkedin} from 'react-icons/bs';

const Links =
{
    PressKit:"https://comingsoon",
    Facebook:"https://www.facebook.com/profile.php?id=61563309324893",
    Instagram:"https://www.instagram.com/screencrowstudios/",
    Twitter:"https://twitter.com/ScreenCrowStudi",
    TikTok:"https://www.tiktok.com/@screencrowstudios",
    YouTube:"https://www.youtube.com/channel/UCLkUQ3pHeMa3E18OwpTsi9Q",
    GitHub:"https://github.com/ScreenCrowStudios",
    Discord:"https://discord.com/invite/hXz7fVqvwv",
    LinkedIn:"https://gr.linkedin.com/company/screencrow-studios"
}

const SocialStyles = 
{
    Text: "!text-base hover:contrast-[.25]",
    Icons:"hover:contrast-[.25] transition-transform duration-200 transform hover:-translate-y-1"
}

const Footer = () =>
{
    return(
        <footer className='footer bg-[#1e1e1e] center align-middle h-32 inset-x-0 bottom-0 md:px-72'>
            <div className='text-[#6b6b6b] font-bold items-center h-full flex flex-col justify-center'>
                <p>
                    ©{new Date().getFullYear()} ScreenCrow Studios. All rights reserved.
                </p>

                <div className='flex'>
                    <a href={Links.PressKit} rel="noreferrer">
                        <p className={SocialStyles.Text}>Press Kit</p>
                    </a>
                </div>
                
                <div className='flex justify-center flex-row gap-x-2'>
                    <a href={Links.Instagram} aria-label="Instagram Profile"> <BsInstagram width='32' className={SocialStyles.Icons}/> </a>
                    <a href={Links.Facebook} aria-label="Facebook Profile"> <BsFacebook width='32' className={SocialStyles.Icons}/> </a>
                    <a href={Links.Twitter} aria-label="Twitter Profile"> <BsTwitterX width='32' className={SocialStyles.Icons}/> </a>
                    <a href={Links.TikTok} aria-label="TikTok Profile"> <BsTiktok width='32' className={SocialStyles.Icons}/> </a>
                    <a href={Links.YouTube} aria-label="YouTube Profile"> <BsYoutube width='32' className={SocialStyles.Icons}/> </a>
                    <a href={Links.GitHub} aria-label="GitHub Organization"> <BsGithub width='32' className={SocialStyles.Icons}/> </a>
                    <a href={Links.Discord} aria-label="Discord Server"> <BsDiscord width='32' className={SocialStyles.Icons}/> </a>
                    <a href={Links.LinkedIn} aria-label="LinkedIn Profile"> <BsLinkedin width='32' className={SocialStyles.Icons}/> </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer;